const state = {
    show: false,
    message: '',
    title: '',
};

const getters = {
    show(state) {
        return state.show;
    },
    message(state) {
        return state.message;
    },
    title(state) {
        return state.title;
    },
};

const mutations = {
    SET_SHOW(state, show) {
        state.show = show;
    },
    SET_MESSAGE(state, message) {
        state.message = message;
    },
    SET_TITLE(state, title) {
        state.title = title;
    },
};

const actions = {
    toggleShow({commit}, show) {
        commit('SET_SHOW', show);
    },
    setMessage({commit}, message) {
        commit('SET_MESSAGE', message);
    },
    setTitle({commit}, message) {
        commit('SET_TITLE', message);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
